import { RiskComparedResult, RiskLevel } from '../models/fna';

function checkRiskAssessment(
  declared: string,
  assessed: string,
): RiskComparedResult {
  if (declared === assessed) {
    return RiskComparedResult.Declared_Equal_To_Assessed;
  }

  if (declared === RiskLevel.CONSERVATIVE) {
    if (assessed === RiskLevel.AGGRESSIVE) {
      return RiskComparedResult.Declared_Less_Than_Assessed;
    }
    if (assessed === RiskLevel.MODERATE) {
      return RiskComparedResult.Declared_Less_Than_Assessed;
    }
  }

  if (declared === RiskLevel.MODERATE) {
    if (assessed === RiskLevel.CONSERVATIVE) {
      return RiskComparedResult.Declared_More_Than_Assessed;
    }
    if (assessed === RiskLevel.AGGRESSIVE) {
      return RiskComparedResult.Declared_Less_Than_Assessed;
    }
  }

  if (declared === RiskLevel.AGGRESSIVE) {
    if (assessed === RiskLevel.CONSERVATIVE) {
      return RiskComparedResult.Declared_More_Than_Assessed;
    }
    if (assessed === RiskLevel.MODERATE) {
      return RiskComparedResult.Declared_More_Than_Assessed;
    }
  }

  console.log(
    '[RiskAssessmentProfileComponent] Should not reach here. declared: ',
    declared,
    'assessed: ',
    assessed,
  );
  throw new Error('Should not reach here');
}

export function riskDeclaredNotEqualRiskAssessed(
  declaredRiskProfile: string | undefined,
  assessedRiskProfile: string | undefined,
): boolean {
  return (
    declaredRiskProfile !== undefined &&
    assessedRiskProfile !== undefined &&
    checkRiskAssessment(declaredRiskProfile, assessedRiskProfile) !==
      RiskComparedResult.Declared_Equal_To_Assessed
  );
}

export function riskDeclaredMoreThanRiskAssessed(
  declaredRiskProfile: string | undefined,
  assessedRiskProfile: string | undefined,
): boolean {
  return (
    declaredRiskProfile !== undefined &&
    assessedRiskProfile !== undefined &&
    checkRiskAssessment(declaredRiskProfile, assessedRiskProfile) ===
      RiskComparedResult.Declared_More_Than_Assessed
  );
}

export function riskDeclaredLessThanRiskAssessed(
  declaredRiskProfile: string | undefined,
  assessedRiskProfile: string | undefined,
): boolean {
  return (
    declaredRiskProfile !== undefined &&
    assessedRiskProfile !== undefined &&
    checkRiskAssessment(declaredRiskProfile, assessedRiskProfile) ===
      RiskComparedResult.Declared_Less_Than_Assessed
  );
}
